import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
  HttpContextToken
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import {SessionService} from "@dabnet-kamu/libs/auth/components/session.service";
// DKM-5193 Cedric: import'suz, DI'sız tampon — libs/ui index'ini çekmez (döngü yok)
import {ekranHataKaydi} from "@dabnet-kamu/libs/ui/shared/services/ekran-hata-kaydi";


export const BYPASS_LOG = new HttpContextToken(() => false);

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private sessionService: SessionService
  ) {}


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.context.get(BYPASS_LOG)) {
      return next.handle(req);
    }

    // Debug: tüm istekler için user/token durumunu izle
    const debugUser = this.authService.loggedUser;

    if (req.url.includes('/connect/token')) {
      return next.handle(req).pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 400 || error.status === 500) {
            this.sessionService.forceLogout();
          }
          return throwError(() => error);
        })
      );
    }

    // Every HTTP request:
    // 1) Use existing user/token if valid
    // 2) Otherwise try silent renew once via ensureValidUser()
    // 3) If silent renew fails or request returns 401/403 → forceLogout

    // Fix: Do not add Authorization header to external requests (e.g. js.devexpress.com)
    // as it triggers CORS errors on domains that don't allow it.
    if (req.url.includes('js.devexpress.com')) {
      return next.handle(req);
    }

    const baslangic = Date.now(); // DKM-5193 Cedric: hata kaydı için süre
    // dtokgoz 16.10: hatanın hangi servisten geldiği (200 dönüp gövdede hata taşıyanlar dahil) destek talebine girsin
    ekranHataKaydi.istek(req.method, req.urlWithParams);
    return from(this.authService.ensureValidUser()).pipe(
      switchMap(user => {
        const token = user.access_token;
        const authReq = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
        });

        return next.handle(authReq);
      }),
      catchError((error: any) => {
        // DKM-5193 Cedric: ekran hata kaydı — yalnız okur; aşağıdaki akış ve yeniden fırlatılan hata nesnesi aynen kalır
        this.hataKaydet(req, error, baslangic);
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401 || error.status === 403) {
            this.sessionService.forceLogout();
          }
        } else {
          this.sessionService.forceLogout();
        }
        return throwError(() => error);
      })
    );
  }

  /**
   * DKM-5193 Cedric: HttpClient hatasını ekran hata kaydına yazar. İstisna dışarı kaçmaz, `error`/`req` değiştirilmez,
   * istek gövdesi ve başlıklar (Authorization) yazılmaz. HttpErrorResponse dışındaki hatalar (oturum yenileme vb.) yazılmaz.
   */
  private hataKaydet(req: HttpRequest<any>, error: any, baslangic: number): void {
    try {
      if (!(error instanceof HttpErrorResponse)) {
        return;
      }
      ekranHataKaydi.http({
        yontem: req.method,
        url: error.url || req.urlWithParams,
        durum: error.status,
        durumMetni: error.statusText,
        govde: error.error,
        sureMs: Date.now() - baslangic,
      });
    } catch {
      // sessiz
    }
  }
}




// import { Injectable, Injector, inject } from '@angular/core';
// import {
//   HttpRequest,
//   HttpHandler,
//   HttpEvent,
//   HttpInterceptor,
//   HttpErrorResponse,
//   HttpContextToken,
// } from '@angular/common/http';
// import {
//   Observable,
//   catchError,
//   finalize,
//   switchMap,
//   takeWhile,
//   tap,
//   throwError,
//   timer,
// } from 'rxjs';
// import { AuthService } from './auth.service';
// import { AuthUtils } from './auth-utils';
// import { UtilsService, environment } from '@dabnet-kamu/libs/ui';
// import { UserActivityService } from './user-activity.service';
//
//  export const BYPASS_LOG = new HttpContextToken(() => false);
//
//
// @Injectable()
// export class AuthInterceptor implements HttpInterceptor {
//
//   constructor(private authService: AuthService,private utilService:UtilsService,private activityService:UserActivityService) {}
//
//   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//     if (req.context.get(BYPASS_LOG) === true)
//     return next.handle(req);
//     if (req.url.includes('/connect/token')) {
//       return next.handle(req).pipe(
//         catchError((error: HttpErrorResponse) => {
//           console.log("fired",error.status)
//           if (error.status === 500 || error.status === 400) {
//             console.error('500 error on /connect/token, redirecting to logout');
//             this.authService.startLogout();
//           }
//           return throwError(error);
//         })
//       );
//     }
//
//
//     return this.authService.getUserInfo().pipe(
//       switchMap(user => {
//
//          this.activityService.isUserActive().subscribe({
//           next:(res)=>{
//             let at=user.expires_at;
//               if(!res && Date.now()>at*1000 ){
//                 let infoShowed=false;
//                 if(!infoShowed){
//                  this.utilService.showInfo('Oturum süresi bitti','')
//                 }
//                 this.authService.startLogout();
//                 infoShowed=true;
//                 return throwError(() => new Error('Session expired due to inactivity.'));
//
//               }else{
//                 const authReq = req.clone({
//                   setHeaders: { Authorization: `Bearer ${user.access_token}` }
//                 });
//                  return next.handle(authReq);
//               }
//           }
//         })
//           this.authService.userManager.events.addUserSignedOut(() => {
//             console.log('User session signout.');
//             this.authService.startLogout();
//
//           });
//
//         if (user && user.access_token && AuthUtils.isTokenExpired(user.access_token, user.expires_at)) {
//            const authReq = req.clone({
//             setHeaders: { Authorization: `Bearer ${user.access_token}` }
//           });
//            return next.handle(authReq);
//         }
//
//
//          return next.handle(req);
//       }),
//       catchError((error) => {
//         if (error instanceof HttpErrorResponse && error.status === 401) {
//           let countdown = 5;
//
//           timer(1000, 1000)
//             .pipe(
//               takeWhile(() => countdown >= 0),
//               tap(() => {
//                 if (countdown > 0) {
//                   this.utilService.showError(
//                     `Giriş ${countdown} saniye sonra sonlanacak`
//                   );
//                 }
//                 countdown--;
//               }),
//               finalize(() => {
//                 console.log("exit")
//                // this.authService.startLogout();
//               })
//             )
//             .subscribe();
//         }
//
//         return throwError(error);
//       })
//
//     );
//   }
// }

